import React from "react";
const IconHide = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M19 8C19 8 13.866 12.5 10 12.5C6.13401 12.5 1 8 1 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path d="M10 13L10 16" stroke="currentColor" strokeWidth="2" />
    <path d="M5.78906 12L4.58906 15.2" stroke="currentColor" strokeWidth="2" />
    <path d="M14.1094 12L15.3094 15.2" stroke="currentColor" strokeWidth="2" />
    <path d="M3 10L1 12" stroke="currentColor" strokeWidth="2" />
    <path d="M17 10L19 12" stroke="currentColor" strokeWidth="2" />
  </svg>
);
export default IconHide;
